import { useAppSelector } from 'app/state'
import { useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { ReactElement } from 'react'
import { FilterByColumnSettings, FilterNumber } from '../../types'
import Between from './Between'
import EqualNumber from './EqualNumber'
import GreaterThan from './GreaterThan'
import GreaterThanOrEqual from './GreaterThanOrEqual'
import LessThan from './LessThan'
import LessThanOrEqual from './LessThanOrEqual'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FilterTypes: Record<FilterNumber, { label: ReactElement; component: (props?: any) => ReactElement }> = {
  [FilterNumber.Between]: {
    label: <FormattedMessage id="analysis.columnValue.numberFilter.type.between" />,
    component: Between
  },
  [FilterNumber.GreaterThan]: {
    label: <FormattedMessage id="analysis.columnValue.numberFilter.type.greaterThan" />,
    component: GreaterThan
  },
  [FilterNumber.LessThan]: {
    label: <FormattedMessage id="analysis.columnValue.numberFilter.type.lessThan" />,
    component: LessThan
  },
  [FilterNumber.Equal]: {
    label: <FormattedMessage id="analysis.columnValue.numberFilter.type.equal" />,
    component: EqualNumber
  },
  [FilterNumber.LessThanOrEqual]: {
    label: <FormattedMessage id="analysis.columnValue.numberFilter.type.lessThanOrEqual" />,
    component: LessThanOrEqual
  },
  [FilterNumber.GreaterThanOrEqual]: {
    label: <FormattedMessage id="analysis.columnValue.numberFilter.type.greaterThanOrEqual" />,
    component: GreaterThanOrEqual
  }
}

export function useNumberFilter(type: FilterNumber) {
  const selectedAnalysis = useAppSelector((state) => state.analysis.selectedAnalysis)
  const [filterSettings, setFilterSettings] = useState<FilterByColumnSettings>()

  const choosenAnalysis = useMemo(() => {
    if (!selectedAnalysis) return

    const filter = FilterTypes[type]
    if (!filter) throw new Error("Choosen filter doesn't exist")

    return filter
  }, [type, selectedAnalysis])

  const ChoosenForm = choosenAnalysis?.component

  return {
    component: ChoosenForm && <ChoosenForm filterSettings={filterSettings} onChange={setFilterSettings} />,
    filterSettings
  }
}
